var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBatteryCharging20Outlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11,20v-3h-4v3.67c0,.73.6,1.33,1.33,1.33h7.33c.74,0,1.34-.6,1.34-1.33v-3.67h-4.4l-1.6,3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.67,4h-1.67v-2h-4v2h-1.67c-.73,0-1.33.6-1.33,1.33v11.67h4v-2.5h-2l4-7.5v5.5h2l-2.4,4.5h4.4V5.33c0-.73-.6-1.33-1.33-1.33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryCharging20Outlined);
export default __webpack_public_path__ + "static/media/BatteryCharging20Outlined.5ed2395f9b8432a48588e5226e0f7635.svg";
export { ForwardRef as ReactComponent };